import axios from 'axios';
import { createAssignmentQuery } from './queries';

const addAssignment = (model) =>
    new Promise((resolve, reject) => {
        const query = createAssignmentQuery({ model });
        const request = axios.post(query.url, { ...query.body });

        request
            .then((response) => {
                resolve({ data: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to add assignment'));
            });
    });

export default addAssignment;
